import { PeekBox, PeekContainer, PeekPaper, PeekStack } from "@piiqtechnologies/ui-components";
import { useAnalytics } from "@piiqtechnologies/ui-lib";
import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Logo from "./Logo";
export const LogoBoxLayout = () => {
    const location = useLocation();
    const analytics = useAnalytics();
    const isTermsAndConditionsAgreement = location.pathname.includes("terms-conditions-agreement");
    useEffect(() => {
        analytics.page();
    }, [location]);
    return (React.createElement(PeekContainer, { maxWidth: "md", sx: { display: "flex", justifyContent: "center" } },
        React.createElement(PeekStack, { height: "100vh", direction: "row", alignItems: "center", justifyContent: "center" },
            React.createElement(PeekPaper, { sx: {
                    width: isTermsAndConditionsAgreement ? 650 : 420,
                    overflow: "hidden",
                }, elevation: 2 },
                React.createElement(PeekStack, { direction: "column" },
                    React.createElement(Logo, null),
                    React.createElement(PeekBox, { p: 3 },
                        React.createElement(Outlet, null)))))));
};
export default LogoBoxLayout;
